import PlusIcon from '../../../icons/plus.icon';
import Layout from '../../../components/layouts/layout.comp'
import { useTranslation } from '../../../core/translation.core';
import Link from 'next/link';
import { DocListFilter } from '../../../types/product';
import { useForm, UseFormReturn, useWatch } from 'react-hook-form';
import { useRouter } from 'next/router';
import PageNav from '../../../components/common/pageNav.comp';
import { useEffect, useRef, useState } from 'react';
import { useListSalesLocation } from '../../../hooks/salesLocation/useGetSales.hook';
import LocalePs from '../../../components/locale/localePs.core';
import PencilIcon from '../../../icons/pencil.icon';
import TrashIcon from '../../../icons/trash.icon';
import Modal from '../../../components/reuseables/modal.comp';
import { LocaleText } from '../../../types/locale';
import useDeleteSalesLocation from '../../../hooks/salesLocation/useDeleteSales.hook';
import Spinner from '../../../components/loaders/Spinner';

export default function LocationPage() {
  const { t, msg } = useTranslation();
  const methods = useFormPagination()

  return (
    <Layout
      title={t(msg.ship.location)}
      titleBtn={
        <Link
          href="/shop/location/add"
          className="text-white hover:bg-blue-700 dark:hover:bg-blue-500 bg-blue-500 dark:bg-blue-600 rounded-3xl px-1 py-1"
        >
          <PlusIcon className="w-5 h-5"></PlusIcon>
        </Link>
      }
    >
      <section className='container mx-auto'>
        <LocationHeader />
        <LocationBody methods={methods} />
        <Paging methods={methods} />
      </section>
    </Layout>
  )
}



function LocationHeader() {
  const { t, msg } = useTranslation();
  return (
    <section data-type="section" className="gap-3 space-y-2 items-end rounded-lg lg:visible hidden lg:grid grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_1fr] lg:gap-2">
      <div>{t(msg.ship.location)}</div>
      <div>{t(msg.ship.addr)}</div>
      <div>{t(msg.pickupAddr.openingHour)}</div>
      <div>{t(msg.pickupAddr.tel)}</div>
      <div>{t(msg.socials.whatsapp)}</div>
      <div>{t(msg.socials.website)}</div>
      <div>{t(msg.inventory.action)}</div>
    </section>
  )
}


function LocationBody({ methods }: { methods: UseFormReturn<DocListFilter, any> }) {
  const { data } = useListSalesLocation(methods);



  return (
    <div className='mt-5'>
      {data?.list?.map(location => (
        <Content
          key={Math.random()}
          location={location} />
      ))}
    </div>
  )
}


function Content({ location }) {
  const btnRef = useRef(null);
  const [modalOpened, setModalOpened] = useState(false);
  const { formhandler, onSubmit } = useDeleteSalesLocation()

  const DeleteComp = ({ name, id }: { name: LocaleText, id: string }) => {
    return (<div className='p-2'>Are you sure you want to remove
      <LocalePs value={name} />
      <button onClick={() => onSubmit(id).then()} className='font-semibold text-xl border'>Yes {formhandler.isPending && <Spinner />} </button>
    </div>)
  }

  return (
    <section data-type="section" className="flex items-center gap-3 space-y-2 rounded-lg lg:grid grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_1fr] lg:gap-2 mt-2">
      <div>
        <LocalePs value={location.name} />
      </div>
      <div>
        <LocalePs value={location.address} />
      </div>
      <div>{location.openingHour}</div>
      <div>{location.tel || "--"}</div>
      <div>{location.whatsapp || "--"}</div>
      <div>{location.website || "--"}</div>
      <div className='flex gap-3'>
        <Link href={`/shop/location/edit?id=${location.id}`}><PencilIcon /></Link>
        <button onClick={() => setModalOpened(true)}><TrashIcon /></button>
      </div>
      {
        modalOpened && (
          <Modal setModalOpened={setModalOpened} btnRef={btnRef}>
            <DeleteComp id={location.id} name={location.name} />
          </Modal>
        )
      }
    </section>
  )
}



function Paging({ methods }: { methods: UseFormReturn<DocListFilter, any> }) {
  const router = useRouter();
  const [pageSize] = useWatch({
    name: ["paging.size"],
    control: methods.control,
  });
  const { data } = useListSalesLocation(methods);

  const total = data?.size;

  return (
    <PageNav
      page={Number(router.query.page) || 1} //
      size={pageSize}
      total={total ?? 0}
      pathname="/shop/location"
      query={router.query}
    />
  );
}


function useFormPagination() {
  const methods = useForm<DocListFilter>()
  const { query, isReady } = useRouter();

  useEffect(() => {
    methods.setValue("paging.page", Number(query.page ?? 1));

    // eslint-disable-next-line
  }, [query, isReady]);

  return methods
}